<template>
	<v-card>
		<v-card-title class="text-h6 grey lighten-2 mb-2 text-break">
			Create Folder in {{ lastUrlPart }} Newsletter Assets
		</v-card-title>
		<v-card-text>
			<v-text-field v-model="newFolderName" autofocus solo label="Folder Name" persistent-hint
				hint="Enter new folder name" />
		</v-card-text>
		<v-card-actions>
			<v-spacer />
			<v-btn rounded small outlined @click="cancel()">Cancel</v-btn>
			<v-btn rounded small color="primary" @click="createFolder()" :disabled="newFolderName.length < 1">Create
				Folder</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import axios from 'axios'
import { TokenService } from '@/services/storage.service'

export default {
	computed: {
		lastUrlPart() {
			// console.log(this.$route.query.folder)

			const pathSegments = window.location.href.split('/');
			return pathSegments[pathSegments.length - 1]; // Get the last element of the array
		}
	},
	methods: {
		cancel() {
			this.$emit('close-dialog')
		},
		isSafeUnixFolderName(str) {
			// Allow alphanumeric characters, spaces, and underscores
			const regex = /^[\w\s]+$/;
			return regex.test(str);
		},
		createFolder() {
			// alert(this.lastUrlPart)
			var params = new URLSearchParams()
			params.append('Username', TokenService.getUsername())
			params.append('token', TokenService.getToken())
			params.append('newsletter', this.lastUrlPart)
			params.append('folder', this.newFolderName)
			if (this.isSafeUnixFolderName(this.newFolderName)) {
				axios.post(process.env.VUE_APP_WEBSITE + '/memberlogin2/createNewsletterFolder.php', params).then(result => {
					this.result = result
					this.cancel()
				}, error => {
					alert('You are not authorized to create this gallery')
					console.error(error)
				})
			} else {
				alert('Folder names can only have letters and numbers')
			}
		}
	},
	data() {
		return {
			newFolderName: ''
		}
	}
}
</script>